import React from "react";

const AboutUs = () => {
  return (
    <div className="wholeDiv">
      <div className="titleText">
        <b>About us</b>
      </div>
      <div className="helpDescription">
        <b>Some information about the server</b>
      </div>
      <div className="textBox">
        <div className="wholeText">
          <div className="perkDescr">
            At <b>kfOne.lt</b>, we are all about nostalgia and our deep love for
            Killing Floor. This server was born from a genuine passion for the
            game and a desire to bring a fresh experience to both long-time fans
            and new players alike.
          </div>
          <div className="perkDescr">
            A lot of effort went into following the vision that we have for how
            the server should look and feel. Every mod, weapon, and map has been
            carefully selected, tweaked, and tidied up to ensure a clean and
            balanced gameplay environment. Our goal is to provide a community
            where players can come together, relive the good old days, and
            discover new surprises along the way.
          </div>
          <div className="perkInfo">
            <b>Thanks to</b>: All the Killing Floor 1 community for creating a
            wide variety of custom weapons, maps and various other mods. A big
            thanks to the older servers we played on as kids, which helped to
            shape our vision and love for the game. Special thanks to Marco,
            creator of ServerPerks, which we used as the foundation for our
            server.
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutUs;
